var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { TeamService } from '../../../../services/workload/team.service';
import { WlmUrls } from '../../../../enums/workload/wlm-urls';
import { WorkloadAuthService } from '../../../../services/workload/workload-auth.service';
import { JobRole } from '../../../../enums/workload/job-role';
var TeamManagerComponent = /** @class */ (function () {
    function TeamManagerComponent(teamService, authService) {
        this.teamService = teamService;
        this.authService = authService;
        this.getTeamsSubscription = new Subscription();
        this.viewModel = {
            teams: [],
            homeTabText: 'All',
            returnToDashboardText: 'Dashboard',
            returnToDashboardUrl: WlmUrls.Dashboard,
            returnToDashboardAltText: 'Return to dashboard',
            createTeam: {
                hasPermissionToCreateTeam: false,
                creation: false,
                imageAltText: 'CREATE',
                teamTitle: 'CREATE'
            }
        };
        this.loadTeams();
    }
    TeamManagerComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authService.getCurrentUser().toPromise().then(function (user) {
                            if (user.role !== JobRole.Admin)
                                _this.authService.unAuthUser();
                            _this.viewModel.createTeam.hasPermissionToCreateTeam = true;
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TeamManagerComponent.prototype.ngOnDestroy = function () {
        if (this.getTeamsSubscription)
            this.getTeamsSubscription.unsubscribe();
    };
    TeamManagerComponent.prototype.mergeTeamLists = function () {
        var teams = [];
        this.viewModel.teams.map(function (teamTab) {
            teams.push(teamTab.team);
        });
        return teams;
    };
    TeamManagerComponent.prototype.userCreatedCallback = function (staff) {
        this.viewModel.teams.filter(function (x) { return x.team.id === staff.teamId; })[0].team.teamMembers.push(staff);
    };
    TeamManagerComponent.prototype.displayCreateTeam = function (displayCreateTeam) {
        this.viewModel.createTeam.creation = displayCreateTeam;
    };
    TeamManagerComponent.prototype.teamCreated = function (newTeam) {
        if (newTeam.id > 0) {
            this.viewModel.createTeam.creation = false;
            this.buildTeamTab(newTeam);
        }
    };
    TeamManagerComponent.prototype.cancelTeamCreate = function () {
        this.viewModel.createTeam.creation = false;
    };
    TeamManagerComponent.prototype.loadTeams = function () {
        var _this = this;
        this.getTeamsSubscription = this.teamService.getTeams().subscribe(function (teamListViewModel) {
            teamListViewModel.teams.map(function (team) {
                _this.buildTeamTab(team);
            });
        });
    };
    TeamManagerComponent.prototype.buildTeamTab = function (team) {
        var name = team.name.replace(' ', '-');
        var tab = {
            targetId: "nav-" + name,
            tabId: "nav-" + name + "-tab",
            href: "#nav-" + name
        };
        this.viewModel.teams.push({
            team: team,
            tab: tab
        });
    };
    TeamManagerComponent = __decorate([
        Component({
            selector: 'team-manager',
            template: require('./team-manager.component.html'),
            styles: [require('./team-manager.component.scss')]
        }),
        __metadata("design:paramtypes", [TeamService,
            WorkloadAuthService])
    ], TeamManagerComponent);
    return TeamManagerComponent;
}());
export { TeamManagerComponent };
//# sourceMappingURL=data:application/json;base64,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